import LocationMask, { handleSlideDistance } from "@/components/BasicLayout/BasicHeader/LocationMask";
import { homeStateSelector } from "@store/redux/modules/home";
import { useSelector } from "react-redux";
import { appThemeStyle } from "@/config";
import { pxChangeVw } from "@/utils";
import sendLog from "@/utils/sendLog";
import { Skeleton } from "antd-mobile";
import { baseDeilyDetailPath } from "@/router";
const Header: React.FC = () => {
  const maskNode = useRef<any>(null);
  const { pathname } = useLocation();
  let { info = {} } = useSelector(homeStateSelector);
  if (isEmptyType(info)) info = LocalStorage.getItem("info");
  const updateChildState = () => {
    maskNode.current.setVisible(!maskNode.current.visible);
  };
  const [isShowLocationIcon] = useState(true);
  useEffect(() => {
    !isDevEnv && sendLog("index_" + pathname?.split?.("/")?.[1]);
  }, [pathname]);
  const animateRef = useRef<any>(null);
  requestAnimationFrame(() => {
    handleSlideDistance({
      end: animateRef?.current?.parentElement?.clientWidth - animateRef?.current?.clientWidth,
    })(animateRef.current);
  });
  const homeState = useSelector(homeStateSelector);
  const weatherStatus = homeState?.info?.weatherStatus || LocalStorage.getItem("info")?.weatherStatus;
  const headerStyle = appThemeStyle?.[weatherStatus]?.headerStyle ?? {};
  const imgStyle = {
    height: "25px",
    marginTop: "12.5px",
  };
  const itemStyle = { height: "50px", lineHeight: "50px" };
  const { isArLan } = useLanguage();
  return isEmptyType(info) ? (
    <Skeleton
      animated
      style={{ "--width": "100%", "--height": pxChangeVw("50px") as string, "--border-radius": "0px" }}
      className="border-b-1 border-b-solid border-b-[rgba(255,255,255,0.2)]"
    />
  ) : (
    pathname.indexOf(baseDeilyDetailPath) != 0 && (
      <div
        className="p-[0_10px] box-border w-full flex justify-between items-center gap-x24 border-b-1 border-b-solid  border-b-[rgba(255,255,255,0.2)]"
        style={{ ...headerStyle, height: "50px", lineHeight: "50px" }}
      >
        <div
          className="flex justify-start items-center"
          style={{ width: isArLan ? "auto" : "60vw", overflow: isArLan ? "visible" : "hidden" }}
          onClick={updateChildState}
        >
          <div className="w-full flex items-center">
            {isShowLocationIcon && (
              <div
                className="flex-[0] box-border"
                style={{
                  paddingLeft: isArLan ? pxChangeVw("10px") : "0px",
                  paddingRight: isArLan ? "0px" : pxChangeVw("10px"),
                }}
              >
                {renderIconFont("icon-weizhi1")}
              </div>
            )}

            <div className="flex-[1]  overflow-hidden">
              <LocationMask ref={maskNode} />
            </div>
          </div>
        </div>
        <div
          className="text-13 whitespace-nowrap overflow-hidden"
          style={{
            width: isArLan ? "auto" : "40vw",
          }}
        >
          <AnimateSlide ref={animateRef} $duration={8} $playState="paused">
            <ul className="inline-block">
              <li className="inline-block mr-8 align-top w-30" style={itemStyle}>
                <WeatherImage className="img" src={info?.WeatherIconImg} style={imgStyle} />
              </li>

              {info?.WeatherText && (
                <li className="inline-block mr-8 align-top " style={itemStyle}>
                  {info.WeatherText}
                </li>
              )}

              {(info?.Temperature?.Value || info?.Temperature?.Unit) && (
                <li className="inline-block mr-8 align-top " style={itemStyle}>
                  {info?.Temperature?.Value}
                  {info?.Temperature?.Unit}
                </li>
              )}

              {(info?.Wind?.Direction?.Localized ||
                info?.Wind?.Speed?.Metric?.Value ||
                info?.Wind?.Speed?.Metric?.Unit) && (
                <li className="inline-block mr-8 align-top " style={itemStyle}>
                  {info?.Wind?.Direction?.Localized} {info?.Wind?.Speed?.Metric?.Value}{" "}
                  {info?.Wind?.Speed?.Metric?.Unit}
                </li>
              )}

              {info?.Wind?.Metric?.Value && (
                <li className="inline-block align-top mr-0" style={itemStyle}>
                  {info.Wind.Metric.Value} {info?.Wind?.Metric?.Unit}
                </li>
              )}
            </ul>
          </AnimateSlide>
        </div>
      </div>
    )
  );
};

export default Header;
